<template lang="pug">
#app
  router-view
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>
<style lang='sass'>
html,body,#app
  width: 100%
  height: 100%
#app
  width: 100%
  height: 100%
  background-color: #000
</style>
